import { render, staticRenderFns } from "./rmqrExtra.vue?vue&type=template&id=5931f88b"
import script from "./rmqrExtra.vue?vue&type=script&lang=ts"
export * from "./rmqrExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports